import Layout from 'components/layout';
import { SetRoutes } from 'components';
import routes from './routes';
import { useLocation } from 'react-router-dom';

const InterviewsPage = () => {
  const { pathname } = useLocation();
  const hideLayout = pathname.includes('print');
  return (
    <Layout hideLayout={hideLayout}>
      <SetRoutes routes={routes} />
    </Layout>
  );
};

export default InterviewsPage;
